module.exports = __webpack_public_path__ + "img/Character_Albedo_Thumb.7b135de7.png";